import apiBaseState from "~/constants/apiBaseState";
import deepClone from "~/utils/deepClone";
import Vueset from "~/utils/Vueset";
import _ from "lodash";

export const state = () => ({
    taskCreateState: apiBaseState(),
    taskUpdateState: apiBaseState(),
    taskSetupState: apiBaseState(),
    taskDeleteState: apiBaseState(),
    taskRestoreState: apiBaseState(),
    taskDestroyState: apiBaseState(),
    taskPublishState: apiBaseState(),
    taskCloneState: apiBaseState(),
    taskCloseState: apiBaseState(),
    taskGroupsState: apiBaseState(),
    taskGroupsSetupState: apiBaseState(),
    taskRoutesState: apiBaseState(),
    taskRouteUpdateState: apiBaseState(),
    taskRouteDeleteState: apiBaseState(),
    taskRouteCreateState: apiBaseState(),
    whatsAppGroups: null
});

export const getters = {
    isPublished(state){
        return state.taskSetupState.data.status === 'live';
    },
    questionIdsAndTypes: state => {
        const groups = state.taskGroupsState.data?.map((group, groupIndex) => (
            group.core_questions.map((core) => ({
                id: core.id,
                type: core.type,
                options: core.options,
                body: `${core.body.replace(/<[^>]+>/g, '')}`,
                question: `Page ${groupIndex + 1} question ${core.order}`,
                answers: core.options.map(opt => opt.label),
                page: groupIndex + 1,
                groupLabel: `Page ${groupIndex + 1}`
            }))
        )) || [];
        return [].concat.apply([], groups);
    },
    questionOrdering: state => {
        const groups = state.taskGroupsState.data?.map((group) => (
            group.core_questions.map((core) => {
                return {
                    id: core.id,
                    questionNo: !core.instruction ? core.question_number : null,
                    isQuestion: !core.instruction,
                };
            })
        )) || [];
        return [].concat.apply([], groups);
    },
};

export const mutations = {
    SET_WHATS_APP_GROUPS(state, payload){
        state.whatsAppGroups = payload;
    },
    SET_TASK_CLONE_STATE(state, payload){
        state.taskCloneState = payload;
    },
    SET_TASK_CLOSE_STATE(state, payload){
        state.taskCloseState = payload;
    },
    SET_TASK_PUBLISH_STATE(state, payload){
        state.taskPublishState = payload;
    },
    SET_TASK_CREATE_STATE(state, payload){
        state.taskCreateState = payload;
    },
    SET_TASK_GROUPS_STATE(state, payload){
        state.taskGroupsState = payload;
    },
    SET_TASK_GROUPS_SETUP_STATE(state, payload){
        state.taskGroupsSetupState = payload;
    },
    SET_TASK_GROUPS_STATE_DATA(state, payload){
        state.taskGroupsState.data = payload;
    },
    SET_TASK_GROUPS_PUSH(state, payload){
        state.taskGroupsState.data[0].core_questions.splice(payload.order, 0, payload);
    },
    SET_TASK_UPDATE_STATE(state, payload){
        state.taskUpdateState = payload;
    },
    SET_TASK_SETUP_STATE(state, payload){
        state.taskSetupState = payload;
    },
    RESET_TASK_SETUP_STATE(state){
        state.taskSetupState = apiBaseState();
    },
    SET_TASK_SETUP_TASK(state, payload){
        state.taskSetupState.data = payload;
    },
    DELETE_TASK_STATE(state, payload){
        state.taskDeleteState = payload;
    },
    RESTORE_TASK_STATE(state, payload){
        state.taskRestoreState = payload;
    },
    DESTROY_TASK_STATE(state, payload){
        state.taskDestroyState = payload;
    },
    ADD_DATA_PARAM(state, payload){
        state.taskSetupState.data.url_data_params.push(payload);
    },
    UPDATE_DATA_PARAM(state, payload){
        const index = state.taskSetupState.data.url_data_params.findIndex(item => item.id === payload.id);
        Vueset(state.taskSetupState.data.url_data_params, index, payload);

    },
    DELETE_DATA_PARAM(state, id){
        const index = state.taskSetupState.data.url_data_params.findIndex(item => item.id === id);
        state.taskSetupState.data.url_data_params.splice(index, 1);
    },
    UPDATE_GROUP(state, payload) {
        const index = state.taskGroupsState.data.findIndex(o => o.id == payload.id);
        const existing = state.taskGroupsState.data[index];
        const next = existing && payload.profile_groups === undefined
            ? {
                ...payload,
                profile_groups: existing.profile_groups,
                profile_group_ids: existing.profile_group_ids,
            }
            : payload;
        state.taskGroupsState.data.splice(index, 1, next);
    },
    UPDATE_GROUP_DF(state, payload) {
        state.taskGroupsState.data[0].core_questions.splice(payload.order - 1, 0, payload);
    },
    DELETE_TASK_GROUP(state, groupIndex) {
        state.taskGroupsState.data.splice(groupIndex, 1);
    },
    ADD_TASK_GROUP(state, payload) {
        state.taskGroupsState.data.splice(payload.order - 1, 0, payload);
    },
    SET_TASK_GROUPS(state, data) {
        state.taskGroupsState.data = data;
    },
    REORDER_TASK_GROUPS(state, reorderIds) {
        // Perform the sort operation within a mutation
        state.taskGroupsState.data.sort((a, b) => {
            const indexA = reorderIds.indexOf(a.id);
            const indexB = reorderIds.indexOf(b.id);
            return indexA - indexB;
        });

        // Update the order property
        state.taskGroupsState.data.forEach((group, index) => {
            group.order = index + 1; // Assuming the order should start at 1
        });
    },
    SET_TASK_GROUPS_ORDER(state, order) {
        const oldGroups = deepClone(state.taskGroupsState.data);
        const newGroups = order.map(id => {
            const index = oldGroups.findIndex(group => group.id === id);
            return oldGroups[index];
        });
        state.taskGroupsState.data = newGroups;
    },
    GET_TASK_ROUTES_STATE(state, data){
        state.taskRoutesState = data;
    },

    CREATE_TASK_ROUTE_STATE(state, data){
        state.taskRouteCreateState = data;
    },

    UPDATE_TASK_ROUTE_STATE(state, data){
        state.taskRouteUpdateState = data;
    },

    DELETE_TASK_ROUTE_STATE(state, data){
        state.taskRouteDeleteState = data;
    },

    ADD_TASK_ROUTE(state, payload){
        state.taskRoutesState.data.push(payload);
    },

    DELETE_TASK_ROUTE(state, id){
        const deleteIndex = state.taskRoutesState.data.findIndex(route => route.id === id);
        state.taskRoutesState.data.splice(deleteIndex, 1);
    },
    UPDATE_TASK_ROUTE(state, {id, label}){
        const route = state.taskRoutesState.data.find(route => route.id === id);
        route.label = label;
    },
    ADD_TASK_PAGE_ROUTE(state, data){
        const {groupId, ...page_route} = data;
        const group = state.taskGroupsState.data.find(group => group.id === groupId);
        group.page_routes.push(page_route);
    },
    DELETE_TASK_PAGE_ROUTE(state, data){
        const {groupId, pageRouteId} = data;
        const group = state.taskGroupsState.data.find(group => group.id === groupId);
        const pageRouteIndex = group.page_routes.findIndex(route => route.id === pageRouteId);
        group.page_routes.splice(pageRouteIndex, 1);
    },
    UPDATE_TASK_PAGE_ROUTE(state, data){
        const {groupId, pageRouteId, ...pageRouteData} = data;
        const groupIndex = state.taskGroupsState.data.findIndex(group => group.id === groupId);
        const pageRouteIndex = state.taskGroupsState.data[groupIndex].page_routes.findIndex(route => route.id === pageRouteId);
        Vueset(state.taskGroupsState.data[groupIndex].page_routes, pageRouteIndex, pageRouteData);
    },
    SET_CORE_QUESTIONS(state, payload) {
        state.taskGroupsState.data[payload.index].core_questions = payload.questions;
    },
    INCREMENT_NEXT_GROUP_ORDERING(state, payload){
        const questionAddedToGroupId = payload.id;
        const questionAddedToGroupIdIndex = state.taskGroupsState.data.findIndex(group => group.id === questionAddedToGroupId);
        state.taskGroupsState.data.forEach((group, gI)=> {
            if(gI > questionAddedToGroupIdIndex){
                group.core_questions.forEach((qu, quI)=> {
                    qu.question_number = `${parseInt(qu.question_number) + 1}`;
                });
            }
        });
    },
    DELETE_QUESTION(state, payload) {
        if(payload.question.additional_question) {
            let index = _.findIndex(state.taskGroupsState.data[payload.groupIndex].additional_questions, {id: payload.question.id});
            state.taskGroupsState.data[payload.groupIndex].additional_questions.splice(index, 1);
        } else {
            let index = _.findIndex(state.taskGroupsState.data[payload.groupIndex].core_questions, {id: payload.question.id});

            state.taskGroupsState.data[payload.groupIndex].core_questions.splice(index, 1);

            state.taskGroupsState.data.forEach((group, gI)=> {
                group.core_questions.forEach((qu, quI)=> {
                    if(gI === payload.groupIndex && quI >= index){
                        qu.question_number = `${parseInt(qu.question_number) - 1}`;
                    }
                    if(gI > payload.groupIndex){
                        qu.question_number = `${parseInt(qu.question_number) - 1}`;
                    }
                });
            });

        }
    },
    UPDATE_QUESTION(state, payload) {
        if(payload.question.additional_question) {
            let index = _.findIndex(state.taskGroupsState.data[payload.groupIndex].additional_questions, {id: payload.question.id});
            state.taskGroupsState.data[payload.groupIndex].additional_questions.splice(index, 1, payload.question);
        } else {
            let index = _.findIndex(state.taskGroupsState.data[payload.groupIndex].core_questions, {id: payload.question.id});
            state.taskGroupsState.data[payload.groupIndex].core_questions.splice(index, 1, payload.question);
        }
    },
};

export const actions = {
    CLONE_TASK(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/clone`;

        return this.$whyApi.post({
            url,
            data: payload,
            mutation: "webTask/SET_TASK_CLONE_STATE",
            errorMessage: "Error cloning task",
            notify: this.$notify
        });
    },
    CLOSE_TASK(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/close-task`;

        return this.$whyApi.post({
            url,
            data: payload,
            mutation: "webTask/SET_TASK_CLOSE_STATE",
            errorMessage: "Error closing task",
            notify: this.$notify
        });
    },
    CREATE_TASK(state, data) {
        const {accountSlug, projectSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/tasks/create`;

        return this.$whyApi.post({
            url,
            data: payload,
            handleErrorLocally: true,
            mutation: "webTask/SET_TASK_CREATE_STATE",
            errorMessage: "Error creating task",
            notify: false
        });
    },
    PUBLISH_TASK(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/publish`;

        return this.$whyApi.put({
            url,
            data: payload,
            mutation: "webTask/SET_TASK_PUBLISH_STATE",
            errorMessage: "Error updating task",
            notify: this.$notify
        });
    },
    UPDATE_TASK(state, data) {
        const {accountSlug, projectSlug, taskSlug, ...payload} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}`;

        return this.$whyApi.put({
            url,
            data: payload,
            handleErrorLocally: true,
            mutation: "webTask/SET_TASK_UPDATE_STATE",
            errorMessage: "Error updating task",
            notify: false
        });
    },
    GET_TASK(state, data) {
        const {accountSlug, projectSlug, taskSlug} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}`;
        return this.$whyApi.get({
            url,
            mutation: "webTask/SET_TASK_SETUP_STATE",
            errorMessage: "Error getting task",
            notify: this.$notify
        });
    },
    GET_TASK_GROUPS(state, data) {
        const {accountSlug, projectSlug, taskSlug} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/groups`;
        return this.$whyApi.get({
            url,
            mutation: "webTask/SET_TASK_GROUPS_STATE",
            errorMessage: "Error getting task groups",
            notify: this.$notify
        });
    },
    GET_TASK_GROUPS_SETUP(state, data) {
        const {accountSlug, projectSlug, taskSlug} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/groups`;
        return this.$whyApi.get({
            url,
            mutation: "webTask/SET_TASK_GROUPS_SETUP_STATE",
            errorMessage: "Error getting task groups",
            notify: this.$notify
        });
    },
    DELETE_TASK(state, data) {
        const {accountSlug, projectSlug, taskSlug} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}`;

        return this.$whyApi.delete({
            url,
            mutation: "webTask/DELETE_TASK_STATE",
            errorMessage: "Error deleting task",
            notify: this.$notify
        });
    },
    DESTROY_TASK(state, data) {
        const {accountSlug, projectSlug, taskSlug} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/destroy`;

        return this.$whyApi.delete({
            url,
            mutation: "webTask/DESTROY_TASK_STATE",
            errorMessage: "Error destroying task",
            notify: this.$notify
        });
    },
    RESTORE_TASK(state, data) {
        const {accountSlug, projectSlug, taskSlug} = data;
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/restore`;

        return this.$whyApi.put({
            url,
            mutation: "webTask/RESTORE_TASK_STATE",
            errorMessage: "Error restoring task",
            notify: this.$notify
        });
    },
    GET_TASK_ROUTES({}, {accountSlug, projectSlug, taskSlug}) {
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/routes`;
        return this.$whyApi.get({
            url,
            mutation: "webTask/GET_TASK_ROUTES_STATE",
            errorMessage: "Error getting task routes"
        });
    },
    CREATE_TASK_ROUTE({}, {accountSlug, projectSlug, taskSlug, label}) {
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/routes`;
        return this.$whyApi.post({
            url,
            mutation: "webTask/CREATE_TASK_ROUTE_STATE",
            errorMessage: "Error creating task route",
            data: {
                label
            }
        });
    },
    UPDATE_TASK_ROUTE({}, {accountSlug, projectSlug, taskSlug, taskRouteId, label}) {
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/routes/${taskRouteId}`;
        return this.$whyApi.put({
            url,
            mutation: "webTask/UPDATE_TASK_ROUTE_STATE",
            errorMessage: "Error updating task route",
            data: {
                label
            }
        });
    },
    DELETE_TASK_ROUTE_STATE({}, {accountSlug, projectSlug, taskSlug, taskRouteId}) {
        const url = `/accounts/${accountSlug}/${projectSlug}/${taskSlug}/routes/${taskRouteId}`;
        return this.$whyApi.delete({
            url,
            mutation: "webTask/DELETE_TASK_ROUTE_STATE",
            errorMessage: "Error deleting task route"
        });
    },
};
